import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

import { theme } from "~/config/theme";

const LEFT_OFFSET = 48;

type GaiaExpandableMapMarkerProps = PropsWithChildren & {
    headerHeight?: 48 | 64;
};

export function GaiaExpandableMapMarker({ children, headerHeight = 48 }: GaiaExpandableMapMarkerProps) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `${LEFT_OFFSET}px 1fr`,
                gridTemplateRows: `${headerHeight}px 1fr`,
                gridTemplateAreas: `
                    "heading heading"
                    "offset content"
                `,
                opacity: 1,

                "@starting-style": {
                    gridTemplateColumns: `${LEFT_OFFSET}px 0fr`,
                    gridTemplateRows: `${headerHeight}px 0fr`,
                    opacity: 0,
                },
                transition: [
                    theme.transitions.create("opacity", {
                        duration: theme.transitions.duration.shortest,
                    }),
                    theme.transitions.create("grid-template-columns", {
                        duration: theme.transitions.duration.shortest,
                    }),
                    theme.transitions.create("grid-template-rows", {
                        duration: theme.transitions.duration.shortest,
                        delay: theme.transitions.duration.shortest,
                    }),
                ].join(", "),

                /*
                    little hack to create a mouseleave buffer area.
                    in some scenarios (error showing/hiding) the height of the marker can change.
                    we want to prevent a mouseleave trigger
                */
                paddingBottom: 5,
            }}
        >
            {children}
        </Box>
    );
}
